export const PLAN_CONTENT = {
  work: {
    name: 'WORK',
    tagline: 'Best if you train at the gym and just want the tracking. Measure every punch, round, and PR, motivate yourself, and build your own workouts.',
    features: [
      'Freestyle Mode',
      'FightCamp Drills',
      'Custom Drills',
      'Session Details & History',
      'Leaderboard',
      'Activity Progression',
      'Achievement and Badges',
      'Streaks',
      'Lifetime Stats',
    ],
    featuresHeader: null,
  },
  all_access: {
    name: 'ALL-ACCESS',
    tagline: 'Best if you want guided workouts at home. Trainer-led boxing and martial arts classes, programs, and the full library, start to finish.',
    features: [
      '2000+ Trainer-led Boxing Workouts',
      '1000+ Trainer-led Kickboxing Workouts',
      '800+ Strength, Conditioning, & Core Workouts',
      '150+ Dynamic Warmup & Recovery Workouts',
      'Programs',
      'Challenges',
      'Beginner, Intermediate, and Advanced Levels',
      'Expert-led Nutrition Programs',
      'Technique Workouts with Accuracy Tracking',
      'Tutorials',
    ],
    featuresHeader: 'Everything in WORK, plus:',
  },
};
